/**
 * The address a firm's browser telephones answer on, from the console's own address.
 *
 * One word per firm, chosen once as its web address, and every public name formed from
 * it (#381): the console at `bt.dispecher.com` has its telephone at
 * `wss://bt.pbx.dispecher.com/ws` — the same word, `pbx` as the second label, `/ws`. The
 * API reads the firm off that name (`BrowserTelephoneName.cs` is this rule in C#) and
 * passes the socket to the firm's PBX, so nobody types the name anywhere; this only tells
 * the administrator what it is.
 *
 * Nothing is suggested where the rule gives nothing: a bare word (`localhost`), an IP
 * address, or a name that already carries the label — a console would never be served on
 * one, but a suggestion of `pbx.pbx.…` would be worse than none.
 */
export function suggestedTelephoneAddress(hostname: string): string | undefined {
  const labels = hostname.toLowerCase().split('.');
  if (labels.length < 2 || labels.some((l) => l === '')) return undefined;
  if (labels.every((l) => /^\d+$/.test(l))) return undefined;
  if (labels[1] === 'pbx') return undefined;
  return `wss://${labels[0]}.pbx.${labels.slice(1).join('.')}/ws`;
}
